import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import {
  CardHeader,
  Divider,
  List,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import React from 'react';
import AddButton from '../../../../components/common/buttons/AddButton';
import STRING_KEYS from '../../../../language/keys';
import { Anchor } from '../../../../components/Anchor';
import { VIEW_MODE } from '../../../../consts/enums';
import { SkillItem } from './TalentSkillItem';
import { SkillsListStyle } from './style';

type TalentSkillProps = {
  skills: Skills[],
  onAddSkillItem?: () => void,
  onRemoveSkillItem?: (id: string) => void,
  onEditSkill?: (updatedItem: Skills) => void,
  formErrors?: ErrorsValidatationDefauls,
  disabled?: boolean,
  viewMode: ViewMode
}

export const TalentSkills = ({
  skills,
  onAddSkillItem,
  onRemoveSkillItem,
  onEditSkill,
  formErrors,
  disabled = false,
  viewMode,
}:TalentSkillProps): JSX.Element => {
  const {
    card,
    cardDisabled,
    cardHeader,
    cardContent,
    listViewMode,
  } = SkillsListStyle;
  const { t: translate } = useTranslation();

  const isReadOnly = viewMode === VIEW_MODE.READ_ONLY;

  const defineSkillsList = () => {
    return skills.map((item:Skills) => {
      return (
        <SkillItem
          key={ item.id }
          id={ item.id }
          name={ item.name }
          level={ item.level }
          onRemoveClick={ onRemoveSkillItem }
          onItemChanged={ onEditSkill }
          error={ formErrors?.skills?.find((error) => error.id === item.id) || null }
          viewMode={ viewMode }
        />
      );
    });
  };

  const canAdd = typeof onAddSkillItem === 'function' && viewMode === VIEW_MODE.EDITABLE;

  const cardStyle = {
    ...card,
    ...(disabled) && cardDisabled,
  };

  return (
    <Card style={ cardStyle }>
      <Anchor id="skills" />
      <CardHeader
        title={ translate(STRING_KEYS.SKILLS) }
        style={ cardHeader }
      />
      <Divider />
      <CardContent style={ cardContent }>
        <List style={ isReadOnly ? listViewMode : {} }>
          {defineSkillsList()}
        </List>
      </CardContent>

      {canAdd && (
        <CardActions>
          <AddButton
            onClick={ onAddSkillItem  }
            disabled={ false }
          />
        </CardActions>
      )}
    </Card>
  );
};

TalentSkills.defaultProps = {
  onAddSkillItem: undefined,
  onRemoveSkillItem: undefined,
  onEditSkill: () => { /* noop */ },
  formErrors: {},
  disabled: false,
};

export default React.memo(TalentSkills);
